import React, { useState } from "react";

import { useSelector } from "@/redux/hooks";
import { getState } from "@/redux/selectors/location";
import getStrainListTileSections from "api/requests/getStrainListTileSections";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import useOnComponentInView from "hooks/useOnComponentInView";
import { getTargetedData } from "utils/getTargetedData";

import FavoriteStrainsSection from "@/components/FavoriteStrainsSection";

import Tile from "./Tile";

type Sections = {
  section_one_title: string;
  section_one_event_category: string;
  section_one_tile_one_title: string;
  section_one_tile_one_link: string;
  section_one_tile_one_image: string;
  section_one_tile_two_title: string;
  section_one_tile_two_link: string;
  section_one_tile_two_image: string;
  section_one_tile_three_title: string;
  section_one_tile_three_link: string;
  section_one_tile_three_image: string;
  section_one_tile_four_title: string;
  section_one_tile_four_link: string;
  section_one_tile_four_image: string;
  section_one_tile_five_title: string;
  section_one_tile_five_link: string;
  section_one_tile_five_image: string;
  section_one_tile_six_title: string;
  section_one_tile_six_link: string;
  section_one_tile_six_image: string;
  section_two_title: string;
  section_two_event_category: string;
  section_two_tile_one_title: string;
  section_two_tile_one_link: string;
  section_two_tile_one_image: string;
  section_two_tile_two_title: string;
  section_two_tile_two_link: string;
  section_two_tile_two_image: string;
  section_two_tile_three_title: string;
  section_two_tile_three_link: string;
  section_two_tile_three_image: string;
  section_two_tile_four_title: string;
  section_two_tile_four_link: string;
  section_two_tile_four_image: string;
  section_two_tile_five_title: string;
  section_two_tile_five_link: string;
  section_two_tile_five_image: string;
  section_two_tile_six_title: string;
  section_two_tile_six_link: string;
  section_two_tile_six_image: string;
};

const TileSection = () => {
  const [sections, setSections] = useState<Sections>();
  const userState = useSelector(getState);
  const countryCode = useDomainCountryCode();

  const [ref] = useOnComponentInView(
    () => {
      getStrainListTileSections(countryCode).then((response) => {
        const sectionsData = getTargetedData(response, userState);
        if (sectionsData?.[0]) {
          setSections(sectionsData?.[0]);
        }
      });
    },
    { triggerOnce: true },
  );

  return (
    <>
      <div ref={ref}>
        {sections?.section_one_title &&
          sections?.section_one_tile_one_title &&
          sections?.section_one_tile_one_link &&
          sections?.section_one_tile_one_image && (
            <div className="py-xxl border-t border-light-grey">
              <h2 className="text-md mb-md">{sections?.section_one_title}</h2>
              <div className="row">
                <Tile
                  title={sections?.section_one_tile_one_title}
                  link={sections?.section_one_tile_one_link}
                  image={sections?.section_one_tile_one_image}
                  eventCategory={sections?.section_one_event_category}
                />
                <Tile
                  title={sections?.section_one_tile_two_title}
                  link={sections?.section_one_tile_two_link}
                  image={sections?.section_one_tile_two_image}
                  eventCategory={sections?.section_one_event_category}
                />
                <Tile
                  title={sections?.section_one_tile_three_title}
                  link={sections?.section_one_tile_three_link}
                  image={sections?.section_one_tile_three_image}
                  eventCategory={sections?.section_one_event_category}
                />
                <Tile
                  title={sections?.section_one_tile_four_title}
                  link={sections?.section_one_tile_four_link}
                  image={sections?.section_one_tile_four_image}
                  eventCategory={sections?.section_one_event_category}
                />
                <Tile
                  title={sections?.section_one_tile_five_title}
                  link={sections?.section_one_tile_five_link}
                  image={sections?.section_one_tile_five_image}
                  eventCategory={sections?.section_one_event_category}
                />
                <Tile
                  title={sections?.section_one_tile_six_title}
                  link={sections?.section_one_tile_six_link}
                  image={sections?.section_one_tile_six_image}
                  eventCategory={sections?.section_one_event_category}
                />
              </div>
            </div>
          )}
      </div>

      <FavoriteStrainsSection />

      <div>
        {sections?.section_two_title &&
          sections?.section_two_tile_one_title &&
          sections?.section_two_tile_one_link &&
          sections?.section_two_tile_one_image && (
            <div className="py-xxl border-t border-light-grey">
              <h2 className="text-md mb-md">{sections?.section_two_title}</h2>
              <div className="row">
                <Tile
                  title={sections?.section_two_tile_one_title}
                  link={sections?.section_two_tile_one_link}
                  image={sections?.section_two_tile_one_image}
                  eventCategory={sections?.section_two_event_category}
                />
                <Tile
                  title={sections?.section_two_tile_two_title}
                  link={sections?.section_two_tile_two_link}
                  image={sections?.section_two_tile_two_image}
                  eventCategory={sections?.section_two_event_category}
                />
                <Tile
                  title={sections?.section_two_tile_three_title}
                  link={sections?.section_two_tile_three_link}
                  image={sections?.section_two_tile_three_image}
                  eventCategory={sections?.section_two_event_category}
                />
                <Tile
                  title={sections?.section_two_tile_four_title}
                  link={sections?.section_two_tile_four_link}
                  image={sections?.section_two_tile_four_image}
                  eventCategory={sections?.section_two_event_category}
                />
                <Tile
                  title={sections?.section_two_tile_five_title}
                  link={sections?.section_two_tile_five_link}
                  image={sections?.section_two_tile_five_image}
                  eventCategory={sections?.section_two_event_category}
                />
                <Tile
                  title={sections?.section_two_tile_six_title}
                  link={sections?.section_two_tile_six_link}
                  image={sections?.section_two_tile_six_image}
                  eventCategory={sections?.section_two_event_category}
                />
              </div>
            </div>
          )}
      </div>
    </>
  );
};

export default TileSection;
